import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ShoppingBag } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const StickyShopBar = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > window.innerHeight * 0.85);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 60, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 60, opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed bottom-0 left-0 right-0 z-50 bg-foreground/95 backdrop-blur-md border-t border-primary-foreground/10 py-2 px-4 md:py-3 md:px-6"
        >
          <div className="container flex items-center justify-between gap-4">
            <p className="font-body text-xs tracking-[0.15em] uppercase text-primary-foreground/60 hidden sm:block">
              Free shipping on orders over €180 within EU
            </p>
            <Button className="h-8 px-5 md:h-10 md:px-8 bg-primary-foreground text-foreground hover:bg-primary-foreground/90 font-body text-[10px] md:text-xs tracking-[0.15em] uppercase rounded-none ml-auto" asChild>
              <Link to="/shop">
                <ShoppingBag size={14} className="mr-2" />
                Shop Now
              </Link>
            </Button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default StickyShopBar;
